import React, { useEffect, useState } from "react";
import $ from "jquery";
import Header from "../../common/Header";
import OwlCarousel from "react-owl-carousel";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import banner1 from "../../../assets/images/banner-1.png";
import banner2 from "../../../assets/images/banner-2.png";
import banner3 from "../../../assets/images/banner-3.png";
import leftArrow from "../../../assets/images/left-arrow.svg";
import domainIcon from "../../../assets/images/domain-icon.svg";
import domainIconWhite from "../../../assets/images/domain-icon-white.svg";
import partyPopper from "../../../assets/images/party-popper.svg";
import closeBlack from "../../../assets/images/close-black.svg";
import tooltipIcon from "../../../assets/images/tooltip-icon.svg";
import LinkBanner1 from "../../../assets/images/onboarding-banner.svg";
import { useToast } from "../../../toast";
import { onAddDomainName } from "../../../services";
import monetization1 from "../../../assets/images/monetization-banner-1.svg";
import monetization2 from "../../../assets/images/monetization-banner-2.svg";
import monetization3 from "../../../assets/images/monetization-banner-3.svg";
import userData from "../../../assets/images/user-data.svg";
import _ from 'lodash';
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";

function Onboarding() {
  const [domainName, setDomainName] = useState("")
  const toast = useToast();
  const profileDetails = useSelector((state) => state.profileDetails)
  const history = useHistory();

  useEffect(() => {
    if (!_.isEmpty(profileDetails)) {
      if (profileDetails?.cp_creator_domains?.length > 0) {
        history.push('/affiliate-dashboard')
      }
    }
  }, [profileDetails])

  const onSubmitDomain = () => {
    if (domainName === "" || !domainName) {
      return
    }
    const regexPattern = /^[\w]+$/
    const testregexPattern = regexPattern.test(domainName)
    if (!testregexPattern) {
      toast.buttomOpen("Please check the domain format")
      return
    }
    let payload = {
      domain_name: domainName
    }
    onAddDomainName(payload).then(res => {
      if (!res.status) {
        toast.buttomOpen(res.message)
        return
      }
      onClose()
      $("#succuss-domain").modal("show")
      setTimeout(() => {
        $("#succuss-domain").modal("hide")
        window.open("https://stage-creatorpro.myjosh.in/affiliate_store/index?d_type=web", "_self")
      }, 3000);
    })
  }
  const onClose = () => {
    setDomainName("")
    $("#create-domain").modal("hide")
  }
  return (
    <>
      {/* <Header className="hide-mob-view" /> */}
      <div className="mobile-responsive-bar">
        <div className="mobile-header-wrap">
          <img src={leftArrow} alt="" />
        </div>
      </div>

      <div className="main-wrapper onboarding-wrap">
        {/* <h2>Marketplace templates that</h2>
          <h2> set you up for success</h2>
          <p>
            Get a headstart on your journey with 900+ free, customizable website
            templates, strategically <br /> researched and tailored for every
            industry — or start from a blank canvas
          </p>
          <div className="common-btn">
            <button data-toggle="modal" data-target="#create-domain">
              Get Started
            </button>
          </div>
          <div className="banner-wrap">
            <img src={banner1} alt="" />
          </div> */}
        <div className="new-link-account-wrap">
          <div className="onboarding-banner-link">
            <div className="blur-bg"></div>
            <div className="link-account-banner">
              <div className="custom-container">
                <div className="row">
                  <div className="col-md-7">
                    <div className="link-account-content">
                      <h2>
                        Earn Money with your <br />
                       <span>own personalized</span> affiliate store
                      </h2>
                      <span>
                        Select from 20000+ affiliate products to curate your own
                        store and earn money via affiliate commissions
                      </span>
                    </div>
                    <div className="common-btn">
                      <button data-toggle="modal" data-target="#create-domain">
                        Get Started
                      </button>
                    </div>
                  </div>
                  <div className="col-md-5">
                    <div className="onboarding-right">
                      <img src={LinkBanner1} alt="" />
                      <div className="user-name-strip">
                        www.creatorpro.com/Deepalisharma
                      </div>
                      <div className="user-details-card">
                        <img src={userData} alt="" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="get-start-section monetization-wrap">
            <h2>Monetization on CreatorPro</h2>
            <div className="custom-container">
              <div className="row">
                <div className="col-md-4">
                  <div className="monetization-card">
                    <img src={monetization1} alt="" />
                    <p>Access 20,000+ brands affiliate products</p>
                    <span>Brands promise up to 10% commission on the sales.</span>
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="monetization-card">
                    <img src={monetization2} alt="" />
                    <p>Earn up to INR 20,000</p>
                    <span>
                      Add branded products and earn via affiliate commission.
                    </span>
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="monetization-card">
                    <img src={monetization3} alt="" />
                    <p>Your own store website</p>
                    <span>
                      Share the store on any platform including Instagram and
                      Youtube.
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="get-start-section own-store-wrap">
            <h2>Curate your Own Store</h2>
            <p>
              Select your personal favorite affiliate products from various
              brand categories, share your store with your friends and you are
              all set to earn money.
            </p>
            <div className="common-btn">
              <button data-toggle="modal" data-target="#create-domain">
                Get Store Link
              </button>
            </div>
          </div>
        </div>
      </div>
      <div className="onboarding-slider-wrap">
      <div className="onboarding-OwlCarousel">
        <OwlCarousel
          className="owl-theme"
          loop={true}
          margin={20}
          nav={false}
          autoWidth={false}
          autoplay={true}
          responsive={{
            0: {
              items: 1,
            },
            600: {
              items: 1,
            },
            1000: {
              items: 3,
            },
          }}
        >
          <div className="item">
            <div className="onboarding-wrap">
              <h2>Access to 20000+ brand affiliate products</h2>
              <p>Brands promise up to 10% commission on the sales.</p>
              <div className="banner-wrap">
                <img src={monetization1} alt="" />
              </div>
            </div>
          </div>
          <div className="item">
            <div className="onboarding-wrap">
              <h2>Earn up to INR 20000</h2>
              <p>Add branded products and earn via affiliate commission.</p>
              <div className="banner-wrap">
                <img src={monetization2} alt="" />
              </div>
            </div>
          </div>
          <div className="item">
            <div className="onboarding-wrap">
              <h2>Your own store website</h2>
              <p>
                Share the store on any platform including Instagram and Youtube.
              </p>

              <div className="banner-wrap">
                <img src={monetization3} alt="" />
              </div>
            </div>
          </div>
        </OwlCarousel>
        <div className="common-btn">
          <button data-toggle="modal" data-target="#create-domain">
            {" "}
            Get Started
          </button>
        </div>
      </div>
      </div>
      <div
        className="modal fade logout-popup-wrap save-store-popup"
        id="succuss-domain"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="exampleModalLabel"
        data-backdrop="static"
        data-keyboard="false"
        aria-hidden="true"
      >
        <div
          className="modal-dialog modal-dialog-centered succuss-domain-custom-popup"
          role="document"
        >
          <div className="modal-content succuss-domain">
            <div className="modal-body ">
              <img src={partyPopper} />
              <p>Congratulations</p>
              <span>Your store is created. Add your first product and start earning</span>
            </div>
          </div>
        </div>
      </div>
      {/* Create Domain Popup Start Here */}
      <div
        className="modal fade logout-popup-wrap link-account-popup domain-create-popup"
        id="create-domain"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="exampleModalLabel"
        data-backdrop="static"
        data-keyboard="false"
        aria-hidden="true"
      >
        <div
          className="modal-dialog modal-dialog-centered custom-popup "
          role="document"
        >
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel">
                Get your own domain
              </h5>
              <button type="button" className="close" data-dismiss="modal">
                <span aria-hidden="true">
                  <img src={closeBlack} alt="" onClick={onClose} />
                </span>
              </button>
            </div>
            <div className="modal-body ">
              <div className="link-account-popup-wrap">
                <img className="domain-img-desktop" src={domainIcon} alt="" />
                <img
                  className="domain-img-mobile"
                  src={domainIconWhite}
                  alt=""
                />
                <h2 className="domain-img-mobile">
                Get Your Own URL{" "}
                  <label className="tooltip-wrap">
                    <img
                      aria-expanded="false"
                      aria-hidden="true"
                      id="metric-dropdown"
                      data-toggle="dropdown"
                      aria-haspopup="true"
                      src={tooltipIcon}
                      alt=""
                    />
                    <div className="right-tooltip">
                      <div
                        className="dropdown-menu  dropdown-toggle"
                        aria-labelledby="metric-dropdown"
                      >
                        <a href="javascript:void(0);">
                        Completely customized link for your website
                        </a>
                      </div>
                    </div>
                  </label>
                </h2>
                <p>
                  Fully customize your site with a domain that fits your needs.
                </p>
                <div className="form-group domain-input-wrap">
                  <div className="domain-prefix">www.creatorpro.com /</div>
                  <input
                    type="text"
                    value={domainName}
                    className="form-control"
                    onChange={(e) => setDomainName(e.target.value)}
                    placeholder="Enter your handle name"
                  />
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <div className="common-btn">
                <button className={`${domainName ? "green-btn" : ""}`} onClick={onSubmitDomain} type="button">Done</button>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Create Domain Popup End Here */}
    </>
  );
}

export default Onboarding;
